/*
 * PMX accessibility layer for the theme's xo-modal drawers (cart, search, menu, bundle).
 * The theme already traps Tab inside an open modal and closes on Escape. This adds what
 * it lacks: dialog semantics and a name, keyboard-reachable labelled triggers that
 * respond to Enter/Space, aria-expanded kept in sync, and focus returned to the trigger
 * on close. Desktop hover mega menus (xo-mega-menu-*) are not dialogs and are skipped.
 */
(function () {
  if (window.__pmxA11y) return;
  window.__pmxA11y = true;

  var NAMES = (window.PMX_A11Y && window.PMX_A11Y.names) || {};
  var lastTrigger = null;

  function modalLabel(name) {
    if (!name) return NAMES.dialog || 'Dialog';
    if (name === 'cart') return NAMES.cart || 'Cart';
    if (name === 'search') return NAMES.search || 'Search';
    if (name.indexOf('xo-menu-hamburger') === 0) return NAMES.menu || 'Menu';
    return null;
  }
  function skip(name) { return !name || name.indexOf('xo-mega-menu') === 0; }
  function hasNativeControl(el) {
    return !!el.querySelector('button:not([aria-hidden="true"]), a[href], input, select, textarea');
  }
  function isOpen(modal) { return modal && modal.hasAttribute('xo-active'); }

  function setupModal(modal) {
    var name = modal.getAttribute('xo-name');
    if (skip(name)) return;
    if (!modal.hasAttribute('role')) modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    if (!modal.hasAttribute('aria-label') && !modal.hasAttribute('aria-labelledby')) {
      var heading = modal.querySelector('h1, h2, h3, h4, h5, h6');
      var label = modalLabel(name) || (heading && heading.textContent.trim()) || (NAMES.dialog || 'Dialog');
      modal.setAttribute('aria-label', label);
    }
  }

  function setupTrigger(t) {
    var name = t.getAttribute('xo-name');
    if (skip(name) || t.__pmxA11y) return;
    t.__pmxA11y = true;
    var modal = document.querySelector('xo-modal[xo-name="' + name + '"]');
    var inside = modal && modal.contains(t);
    if (!hasNativeControl(t)) {
      if (!t.hasAttribute('role')) t.setAttribute('role', 'button');
      if (!t.hasAttribute('tabindex')) t.setAttribute('tabindex', '0');
      if (!t.hasAttribute('aria-label') && !t.textContent.trim()) {
        var base = modalLabel(name) || (NAMES.dialog || 'Dialog');
        t.setAttribute('aria-label', inside ? (NAMES.close || 'Close') : base);
      }
      if (!inside) t.setAttribute('aria-haspopup', 'dialog');
      // The theme already turns Enter (and Space) on a role="button" element into a click,
      // so no key handler here (adding one double-toggled the drawer).
    }
    if (!inside) t.setAttribute('aria-expanded', String(isOpen(modal)));
    if (name === 'cart' && !inside) t.__pmxCart = true;
    t.addEventListener('click', function () { if (!inside) lastTrigger = t; });
  }

  function syncExpanded(modal) {
    var name = modal.getAttribute('xo-name');
    var open = isOpen(modal);
    document.querySelectorAll('xo-modal-trigger[xo-name="' + name + '"][aria-expanded]').forEach(function (t) {
      t.setAttribute('aria-expanded', String(open));
    });
    if (!open && lastTrigger && lastTrigger.getAttribute('xo-name') === name) {
      var a = document.activeElement;
      if (!a || a === document.body || modal.contains(a)) {
        var back = lastTrigger;
        lastTrigger = null;
        if (back.isConnected && back.offsetParent !== null) {
          try { back.focus({ preventScroll: true }); } catch (err) { back.focus(); }
        }
      }
    }
  }

  // Links that contain only images (the theme's "image link" option, image buttons) have no text; when their images
  // carry no alt either, name the link from its destination: /collections/pursuit-series
  // -> "Pursuit series". Links that already have a name are left alone.
  function nameImageLinks() {
    document.querySelectorAll('a[href]:not([aria-label]):not([aria-labelledby])').forEach(function (a) {
      if (a.textContent.trim() || !a.querySelector('img') || a.querySelector('svg title')) return;
      var imgs = a.querySelectorAll('img');
      for (var i = 0; i < imgs.length; i++) { if ((imgs[i].getAttribute('alt') || '').trim()) return; }
      var href = a.getAttribute('href') || '';
      var seg = href.split('?')[0].split('#')[0].replace(/\/+$/, '').split('/').pop() || '';
      try { seg = decodeURIComponent(seg); } catch (e) {}
      seg = seg.replace(/[-_]+/g, ' ').trim();
      if (!seg || /^www\./.test(seg) || seg.indexOf('.') > -1 && seg.indexOf(' ') === -1) seg = NAMES.home || 'PROMIXX';
      a.setAttribute('aria-label', seg.charAt(0).toUpperCase() + seg.slice(1));
    });
  }

  // The cart trigger's only text is the item count ("0"), so give it a real name that
  // follows the count. Re-run on every DOM change (the count re-renders).
  function labelCartTriggers() {
    document.querySelectorAll('xo-modal-trigger[xo-name="cart"]').forEach(function (t) {
      if (!t.__pmxCart) return;
      var n = parseInt((t.textContent || '').replace(/[^0-9]/g, ''), 10);
      var base = NAMES.cart || 'Cart';
      var label = isNaN(n) ? base : base + ', ' + n + ' ' + (n === 1 ? (NAMES.item || 'item') : (NAMES.items || 'items'));
      if (t.getAttribute('aria-label') !== label) t.setAttribute('aria-label', label);
    });
  }

  function scan() {
    document.querySelectorAll('xo-modal').forEach(setupModal);
    document.querySelectorAll('xo-modal-trigger').forEach(setupTrigger);
    nameImageLinks();
    labelCartTriggers();
  }

  var pending = false;
  function queueScan() {
    if (pending) return;
    pending = true;
    setTimeout(function () { pending = false; scan(); }, 150);
  }

  function init() {
    scan();
    new MutationObserver(function (records) {
      var structural = false;
      records.forEach(function (r) {
        if (r.type === 'attributes' && r.target.tagName === 'XO-MODAL') syncExpanded(r.target);
        else if (r.type === 'childList' && r.addedNodes.length) structural = true;
      });
      if (structural) queueScan();
    }).observe(document.documentElement, { subtree: true, childList: true, attributes: true, attributeFilter: ['xo-active'] });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', queueScan);
})();
